// extracted by css-extract-rspack-plugin
export default {"mainChart":"Skeleton-module__mainChart__v1Jf6","title":"Skeleton-module__title___KGYO","subtitle":"Skeleton-module__subtitle__gv8bu"};